import { render } from "./EPBanner.vue?vue&type=template&id=cfe2c72c&scoped=true"
import script from "./EPBanner.vue?vue&type=script&lang=js"
export * from "./EPBanner.vue?vue&type=script&lang=js"

import "./EPBanner.vue?vue&type=style&index=0&id=cfe2c72c&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfe2c72c"]])

export default __exports__